import { render, staticRenderFns } from "./DarkTrial.vue?vue&type=template&id=1fc64cf8&"
import script from "./DarkTrial.vue?vue&type=script&setup=true&lang=js&"
export * from "./DarkTrial.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports